import { render, staticRenderFns } from "./NLPTask.vue?vue&type=template&id=05af0698&scoped=true"
import script from "./NLPTask.vue?vue&type=script&lang=js"
export * from "./NLPTask.vue?vue&type=script&lang=js"
import style0 from "./NLPTask.vue?vue&type=style&index=0&id=05af0698&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05af0698",
  null
  
)

export default component.exports